import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { getIntl } from '../../utils/intl';
import { getUniqueLabCodesCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';
import urls from '../../utils/urls';
import { appAPI } from '../../utils/api';

const intl = getIntl('use-unique-labs', {
    loadError: 'Error occurred loading labs',
});

export type UseUniqueLabsArgs = {
    medicalProfileId: string;
};

export type UseUniqueLabsReturnValue = {
    isLoadingUniqueLabs: boolean;
    uniqueLabs: APITypes.medicalDataService.GetUniqueLabCodesResponse;
};

export const useUniqueLabs = ({ medicalProfileId }: UseUniqueLabsArgs): UseUniqueLabsReturnValue => {
    const uniqueLabsQuery = useQuery<APITypes.medicalDataService.GetUniqueLabCodesResponse>({
        queryKey: getUniqueLabCodesCacheKey(medicalProfileId),
        queryFn: async (): Promise<APITypes.medicalDataService.GetUniqueLabCodesResponse> => {
            const response = await appAPI.get<APITypes.medicalDataService.GetUniqueLabCodesResponse>(
                urls.api.medicalData.uniqueLabCodes(medicalProfileId),
            );
            return response;
        },
    });

    useQueryErrorNotify(uniqueLabsQuery, intl('loadError'));

    return {
        isLoadingUniqueLabs: uniqueLabsQuery.isLoading,
        uniqueLabs: uniqueLabsQuery.data || { codes: [] },
    };
};
